/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskCustomRulesCreate } from "../funcs/riskCustomRulesCreate.js";
import { riskCustomRulesDelete } from "../funcs/riskCustomRulesDelete.js";
import { riskCustomRulesGet } from "../funcs/riskCustomRulesGet.js";
import { riskCustomRulesList } from "../funcs/riskCustomRulesList.js";
import { riskCustomRulesSuggest } from "../funcs/riskCustomRulesSuggest.js";
import { riskCustomRulesUpdate } from "../funcs/riskCustomRulesUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListCustomDetectionRulesResult } from "../models/components/listcustomdetectionrulesresult.js";
import { RiskCustomDetectionRule } from "../models/components/riskcustomdetectionrule.js";
import { SuggestCustomDetectionRuleResult } from "../models/components/suggestcustomdetectionruleresult.js";
import {
  CreateCustomDetectionRuleRequest,
  CreateCustomDetectionRuleSecurity,
} from "../models/operations/createcustomdetectionrule.js";
import {
  DeleteCustomDetectionRuleRequest,
  DeleteCustomDetectionRuleSecurity,
} from "../models/operations/deletecustomdetectionrule.js";
import {
  GetCustomDetectionRuleRequest,
  GetCustomDetectionRuleSecurity,
} from "../models/operations/getcustomdetectionrule.js";
import {
  ListCustomDetectionRulesRequest,
  ListCustomDetectionRulesSecurity,
} from "../models/operations/listcustomdetectionrules.js";
import {
  SuggestCustomDetectionRuleRequest,
  SuggestCustomDetectionRuleSecurity,
} from "../models/operations/suggestcustomdetectionrule.js";
import {
  UpdateCustomDetectionRuleRequest,
  UpdateCustomDetectionRuleSecurity,
} from "../models/operations/updatecustomdetectionrule.js";
import { unwrapAsync } from "../types/fp.js";

export class CustomRules extends ClientSDK {
  /**
   * createCustomDetectionRule risk
   *
   * @remarks
   * Create a custom regex-backed detection rule for the current project.
   */
  async create(
    request: CreateCustomDetectionRuleRequest,
    security?: CreateCustomDetectionRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskCustomDetectionRule> {
    return unwrapAsync(riskCustomRulesCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteCustomDetectionRule risk
   *
   * @remarks
   * Delete a custom detection rule.
   */
  async delete(
    request: DeleteCustomDetectionRuleRequest,
    security?: DeleteCustomDetectionRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(riskCustomRulesDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getCustomDetectionRule risk
   *
   * @remarks
   * Get a custom detection rule by ID.
   */
  async get(
    request: GetCustomDetectionRuleRequest,
    security?: GetCustomDetectionRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskCustomDetectionRule> {
    return unwrapAsync(riskCustomRulesGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listCustomDetectionRules risk
   *
   * @remarks
   * List custom detection rules for the current project.
   */
  async list(
    request?: ListCustomDetectionRulesRequest | undefined,
    security?: ListCustomDetectionRulesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListCustomDetectionRulesResult> {
    return unwrapAsync(riskCustomRulesList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * suggestCustomDetectionRule risk
   *
   * @remarks
   * Suggest a custom detection rule (rule_id, title, description, regex, severity) from a natural-language prompt. Calls the configured LLM with a JSON-schema constrained response so the dashboard can prefill the create form.
   */
  async suggest(
    request: SuggestCustomDetectionRuleRequest,
    security?: SuggestCustomDetectionRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SuggestCustomDetectionRuleResult> {
    return unwrapAsync(riskCustomRulesSuggest(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateCustomDetectionRule risk
   *
   * @remarks
   * Update a custom detection rule.
   */
  async update(
    request: UpdateCustomDetectionRuleRequest,
    security?: UpdateCustomDetectionRuleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RiskCustomDetectionRule> {
    return unwrapAsync(riskCustomRulesUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
